
/*
Version 1, pour le moment on ne gère que le formatage à partir des classes CSS MF.
Exemple d'intégration : on ajoute l'attribut data-euro dans la balise qui encapsule le prix.
<p data-euro="{{product.averageFareFeeMargin}}" class="c-strong price lh--n">
{{product.averageFareFeeMargin.int | number:0}}<span class="price__decimal">{{ getText("_DecimalSeparator") + product.averageFareFeeMargin.dec + ' ' + getText("_CurrencySymbol" + product.currency) }}</span>
</p>
Ici, la sous-partie <span class="price__decimal"> affiche les centimes. Dès lors, s'il existe d'autres formattages alors soit intégrer une logique
complémentaire de data-pricetemplate qui peut valoir 0, 1, 2 etc. (0 défault pour auto).
Une prochaine version pourra éventuellement intégrer l'absence d'attibut data-pricetemplate ou égal à 0
pour que le contenu de la balise soit pris et les zones entières, décimales et symbole soit détectées en préservant le reste.
*/
const CurrencyManager = new function () {

    this._decimalSeparator = null;

    this.addCurrency = function (currencyId) {
        if (currencyId !== "EUR" && CurrencyManager.isEnabled() === false) {
            return;
        }
        if (CurrencyManager.currencies == null) {
            CurrencyManager.currencies = [];
        }
        const currencyMenuItem = document.getElementById("currencyMenuItem_" + currencyId);
        var newCurrency = { id: currencyId, htmlsymbol: CurrencyManager.getCurrencyHtmlSymbol(currencyId), symbol: CurrencyManager.getCurrencySymbol(currencyId) };
        if (currencyMenuItem != null) {
            if (newCurrency.id === "EUR") {
                var currencyEncashment = "(Currency encashment)";
                if (CurrencyManager.isCurrencySymbolAfter() === true) {
                    currencyEncashment = "(Devise d’encaissement)";
                }
                else if (window.lng === "nl-BE") {
                    currencyEncashment = "(Valuta inning)";
                }
                currencyMenuItem.innerHTML = newCurrency.id + '<span style="margin-left:4px;" class="d-md-inline">' + newCurrency.htmlsymbol + ' ' + currencyEncashment + '</span>';
            }
            else {
                currencyMenuItem.innerHTML = newCurrency.id + '<span style="margin-left:4px;" class="d-md-inline">' + newCurrency.htmlsymbol + '</span>';
            }
        }
        CurrencyManager.currencies.push(newCurrency);
        console.log("CurrencyManager.addCurrency", currencyId, CurrencyManager.currencies);
    }

    this.getConversionRate = function () {
        //console.info("CurrencyManager.getConversionRate is implemented");
        if (CurrencyManager.isEnabled() === false) {
            CurrencyManager.currency.rateFromEuro = 1;
            CurrencyManager.updatePriceItems();
            return;
        }
        //console.info("CurrencyManager.getConversionRate implemented", data);
        var data = {
            from: "EUR",
            to: CurrencyManager.currency.id,
            checkindate: new Date(),
            bookingdate: new Date(),
            networkcode: "KOETEST",
            application: "FRONT",
        };
        window.Typescript.Currency.Services.CurrencyService.getConversionRate(data).then(function (axiosResponse) {
            try {
                CurrencyManager.currency.rateFromEuro = parseFloat(axiosResponse.data);
            }
            catch (ex) {
                console.info("CurrencyManager.getConversionRate", CurrencyManager.currency, ex);
            }
            if (isNaN(CurrencyManager.currency.rateFromEuro)) {
                CurrencyManager.currency.rateFromEuro = 1;
            }
           
            setTimeout(function () {
                const sel = document.querySelectorAll('[ng-click^="setReady"]');
                const observer = new MutationObserver(mutations => {
                    for (const m of mutations) {
                        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
                            CurrencyManager.updatePriceItems();
                        }
                    }
                });
                sel.forEach(function (el) {
                    observer.observe(el, {
                        childList: true,
                        subtree: true
                    });
                });
            }, 5000);

           
            for (var i = 0; i < 30; i = i + 5) {
                const ms = i * 1000;
                setTimeout(function () {
                    console.info('Call ' + ms + 'milliseconds CurrencyManager.updatePriceItems ' + CurrencyManager.currency.rateFromEuro);
                    CurrencyManager.updatePriceItems();
                }, ms);
            }

            /*
            ugly mais fonctionne si pas tout chargé (pour éviter algo récursif) et l'alternative c'est 
            document.addEventListener('click', (event) => {
                CurrencyManager.updatePriceItems();
            });
            */
        });
    }

    this.getCookie = function (name) {
        //console.log("CurrencyManager.getCookie", name);
        let cookie = {};
        document.cookie.split(';').forEach(function (el) {
            let [key, value] = el.split('=');
            cookie[key.trim()] = value;
        });
        return cookie[name];
    }

    this.getCurrencyHtmlSymbol = function (currencyId) {
        //console.info("CurrencyManager.getCurrencyHtmlSymbol", currencyId);
        switch (currencyId.toUpperCase()) {
            case "EUR": return "€";
            case "GBP": return "&pound;";
            case "USD": return "&dollar;";
            case "INR": return "&#x20B9;";
            case "JPY": return "&yen;";
        }
        return "?";
    }

    this.getCurrencySymbol = function (currencyId) {
        //console.info("CurrencyManager.getCurrencySymbol", currencyId);
        switch (currencyId.toUpperCase()) {
            case "EUR": return "€";
            case "GBP": return "£";
            case "USD": return "$";
            case "INR": return "⟨₹⟩";
            case "JPY": return "¥";
        }
        return "?";
    }

    this.getDecimalSeparator = function (locale) {
        //console.info("CurrencyManager.getDecimalSeparator", locale);
        if (CurrencyManager._decimalSeparator == null) {
            const numberWithDecimalSeparator = 1.1;
            CurrencyManager._decimalSeparator = Intl.NumberFormat(locale)
                .formatToParts(numberWithDecimalSeparator)
                .find(part => part.type === "decimal")
                .value;
        }
        return CurrencyManager._decimalSeparator;
    }

    this.getNumberAtHundredth = function (value) {
        //faster than value.toFixed(2)
        return Math.round(value * 100) / 100;
    }

    this.getPriceItemFromEuro = function (euroPrice) {
        if (!CurrencyManager.isEnabled()) return euroPrice;
        if (isNaN(euroPrice)) {
            console.warn("CurrencyManager.getPriceItemFromEuro euroPrice isNaN");
            return euroPrice;
        }
        return CurrencyManager.getNumberAtHundredth(CurrencyManager.getNumberAtHundredth(euroPrice) * CurrencyManager.currency.rateFromEuro);
    }

    this.getPriceItemSpecificBaggage = function (description) {
        if (!CurrencyManager.isEnabled()) return description;
        var decimalSeparator = CurrencyManager.getDecimalSeparator(window.lng);
        if (description == null) {
            console.info("CurrencyManager.getPriceItemSpecificBaggage no description");
            return description;
        }
        else {
            var bagDescription = description.split(":");
            var euroPrice = parseFloat(bagDescription[1].replace(",", ".").replace(/\D+\.?\D+/g, ""));
            if (isNaN(euroPrice)) {
                console.info("CurrencyManager.getPriceItemSpecificBaggage euroPrice isNaN");
            }
            else {
                if (euroPrice === 0) {
                    if (CurrencyManager.isCurrencySymbolAfter() === true) {
                        return bagDescription[0].trim() + " : 0 " + CurrencyManager.currency.htmlsymbol;
                    }
                    else {
                        return bagDescription[0].trim() + ": " + CurrencyManager.currency.htmlsymbol + "0";
                    }
                }
                var targetPrice = CurrencyManager.getPriceItemFromEuro(euroPrice).toFixed(2).split(".");
                if (CurrencyManager.isCurrencySymbolAfter() === true) {
                    return bagDescription[0].trim() + " : " + targetPrice.join(decimalSeparator) + " " + CurrencyManager.currency.htmlsymbol;
                }
                else {
                    return bagDescription[0].trim() + ": " + CurrencyManager.currency.htmlsymbol + targetPrice.join(decimalSeparator);
                }
            }
        }
    }

    this.getPriceItemSpecificSeatMap = function (description, roundUp) {
        console.info("CurrencyManager.getPriceItemSpecificSeatMap", description, roundUp);
        var euroPrice = parseFloat(description.trim());
        if (isNaN(euroPrice)) {
            console.warn("CurrencyManager.getPriceItemSpecificSeatMap euroPrice isNaN");
        }
        else {
            var targetPrice = CurrencyManager.getPriceItemFromEuro(euroPrice);
            if (roundUp === true) {
                if (CurrencyManager.isCurrencySymbolAfter() === true) {
                    return Math.ceil(targetPrice).toFixed(0) + " " + CurrencyManager.currency.htmlsymbol;
                }
                else {
                    return CurrencyManager.currency.htmlsymbol + Math.ceil(targetPrice).toFixed(0);
                }
            }
            else {
                if (CurrencyManager.isCurrencySymbolAfter() === true) {
                    return targetPrice.toFixed(2) + " " + CurrencyManager.currency.symbol;
                }
                else {
                    return CurrencyManager.currency.symbol + targetPrice.toFixed(2);
                }
            }
        }
    }

    this.isCurrencySymbolAfter = function () {
        return window.lng.toLowerCase().indexOf("fr-") > -1
            || window.lng.toLowerCase().indexOf("it-it") > -1;
    }

    this.isEnabled = function () {
        console.log("window.lng.toLowerCase()", window.lng.toLowerCase());
        console.log("CurrencyManager.isEnabled", window.site.currencyManagerEnabled);
        return window.site.currencyManagerEnabled;
    }

    this.setCurrency = function (currencyId) {
        //console.log("CurrencyManager.setCurrency", currencyId);
        if (CurrencyManager.isEnabled() === false) {
            currencyId = "EUR";
        }
        if (CurrencyManager.currencies == null) {
            CurrencyManager.addCurrency("EUR");
        }
        CurrencyManager.currency = CurrencyManager.currencies.find(({ id }) => id === currencyId);
        this.setCookie("currency", currencyId);
        var currencyBtn = document.getElementById("currencyBtn");
        if (currencyBtn != null) {
            currencyBtn.innerHTML = CurrencyManager.currency.id + '<span style="margin-left:4px;" class="d-md-inline">' + CurrencyManager.currency.htmlsymbol + '</span>';
        }
        if (CurrencyManager.currency.rateFromEuro == null) {
            CurrencyManager.getConversionRate();
        }
        else {
            CurrencyManager.updatePriceItems();        }
    }

    this.setCookie = function (name, value, expiringDays) {
        //console.log("CurrencyManager.setCookie", name, value, expiringDays);
        if (expiringDays == null) {
            expiringDays = 1;
        }
        let date = new Date();
        date.setTime(date.getTime() + (expiringDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; " + expires + "; path=/";
    }

    this.updatePriceItems = function () {
        if (!CurrencyManager.isEnabled()) return;
        try {
            var priceItems = document.querySelectorAll("*[data-euro]");
            var decimalSeparator = CurrencyManager.getDecimalSeparator(window.lng);
            var errors = 0;
            priceItems.forEach(function (priceItem, index) {
                try {
                    var euroPrice = parseFloat(priceItem.getAttribute("data-euro").replace(",", "."));
                    if (isNaN(euroPrice)) {
                        console.warn("CurrencyManager.updatePriceItems euroPrice isNaN", priceItem);
                    }
                    else {
                        var currencyFormat = priceItem.getAttribute("data-currencyformat");
                        var targetPrice = CurrencyManager.getPriceItemFromEuro(euroPrice).toFixed(2).split(".");
                        var decimalSpan = priceItem.querySelector("span");
                        var decimalSpanClass = decimalSpan == null ? null : decimalSpan.getAttribute("class");
                        var prefix = "";
                        if (priceItem.innerHTML.indexOf("+ ") > -1) {
                            prefix = "+ ";
                        }
                        else if (priceItem.innerHTML.indexOf("- ") > -1) {
                            prefix = "- ";
                        }
                        if (decimalSpan == null) {
                            if (CurrencyManager.isCurrencySymbolAfter() === true) {
                                priceItem.innerHTML = prefix + targetPrice.join(decimalSeparator) + " " + CurrencyManager.currency.htmlsymbol;
                            }
                            else {
                                priceItem.innerHTML = prefix + CurrencyManager.currency.htmlsymbol + "" + targetPrice.join(decimalSeparator);
                            }
                        }
                        else {
                            if (CurrencyManager.isCurrencySymbolAfter() === true) {
                                priceItem.innerHTML = prefix + targetPrice[0] + '<span class="' + decimalSpanClass + '">' + decimalSeparator + targetPrice[1] + ' ' + CurrencyManager.currency.htmlsymbol + '</span>';
                            }
                            else {
                                priceItem.innerHTML = prefix + CurrencyManager.currency.htmlsymbol + '' + targetPrice[0] + '<span class="' + decimalSpanClass + '">' + decimalSeparator + targetPrice[1] + '</span>';
                            }
                        }
                    }
                }
                catch (ex) {
                    errors++;
                    console.error("CurrencyManager.updatePriceItems " + index, priceItem, ex);
                }
            });
            priceItems = document.querySelectorAll("*[data-currencyhideifeuro]");
            priceItems.forEach(function (priceItem, index) {
                try {
                    var currencyHideIfEuro = priceItem.getAttribute("data-currencyhideifeuro") === "true";
                    if (currencyHideIfEuro === true && CurrencyManager.currency.id === "EUR") {
                        priceItem.style.display = "none";
                    }
                    else {
                        priceItem.style.display = "block";
                    }
                }
                catch (ex) {
                    errors++;
                    console.error("CurrencyManager.updatePriceItems " + index, priceItem, ex);
                }
            });
            //console.log("CurrencyManager.updatePriceItems " + CurrencyManager.currency.id + ". Found: " + priceItems.length + " Errors: " + errors);

            this.updatePriceItemsSpecific();
            if (document.location.href.indexOf("airsearch") === -1) {
                setTimeout(function () {
                    CurrencyManager.updatePriceItems();
                }, 3000);
            }
        }
        catch (ex) {
            console.error("CurrencyManager.updatePriceItems", ex);
        }
      
    }

    this.updatePriceItemsSpecific = function () {
        if (!CurrencyManager.isEnabled()) return;
        CurrencyManager.updatePriceItemsSpecificBaggages();
        CurrencyManager.updatePriceItemsSpecificSeatMap();
    }

    this.updatePriceItemsSpecificBaggages = function () {
        if (!CurrencyManager.isEnabled()) return;
        var priceItems = document.querySelectorAll('*[ng-repeat="bag in it.additionalBaggages"],*[ng-if="pax.inner.baggageByItinerary[it.key] != null"]');
        var errors = 0;
        priceItems.forEach(function (priceItem, index) {
            try {
                var dataDescriptionAttribute = priceItem.getAttribute("data-description");
                var dataEuroDescriptionAttribute = priceItem.getAttribute("data-eurodescription");
                if (dataEuroDescriptionAttribute != null) {
                    priceItem.innerHTML = CurrencyManager.getPriceItemSpecificBaggage(dataEuroDescriptionAttribute);
                }
                else if (dataDescriptionAttribute != null) {
                    priceItem.innerHTML = CurrencyManager.getPriceItemSpecificBaggage(dataDescriptionAttribute);
                }
            }
            catch (ex) {
                errors++;
                console.error("CurrencyManager.updatePriceItemsSpecificBaggages " + index, priceItem, ex);
            }
        });

        var notSelected = document.querySelectorAll('*[ng-if="pax.inner.baggageByItinerary[it.key][0] == null"],*[ng-if="pax.inner.baggageByItinerary[it.key][1] == null"]');
        notSelected.forEach(function (priceItem, index) {
            try {
                var dataDescriptionAttribute = priceItem.getAttribute("data-description");
                var dataEuroDescriptionAttribute = priceItem.getAttribute("data-eurodescription");
                if (dataEuroDescriptionAttribute != null) {
                    priceItem.innerHTML = CurrencyManager.getPriceItemSpecificBaggage(dataEuroDescriptionAttribute);
                }
                else if (dataDescriptionAttribute != null) {
                    priceItem.innerHTML = CurrencyManager.getPriceItemSpecificBaggage(dataDescriptionAttribute);
                }
            }
            catch (ex) {
                errors++;
                console.error("updatePriceItemsSpecificBaggages " + index, priceItem, ex);
            }
        });
    }

    this.updatePriceItemsSpecificSeatMap = function () {
        if (!CurrencyManager.isEnabled()) return;
        var priceItems = document.querySelectorAll(".c-deck.seat-map td.seat.seat-price, .c-selected-seat-price");
        var errors = 0;
        priceItems.forEach(function (priceItem, index) {
            try {
                if (priceItem.getAttribute("data-euro") == null) {
                    priceItem.setAttribute("data-euro", parseFloat(priceItem.innerText));
                }
                priceItem.setAttribute("title", CurrencyManager.getPriceItemSpecificSeatMap(priceItem.getAttribute("data-euro"), false));
                priceItem.innerHTML = CurrencyManager.getPriceItemSpecificSeatMap(priceItem.getAttribute("data-euro"), true);
            }
            catch (ex) {
                errors++;
                console.info("CurrencyManager.updatePriceItemsSpecificSeatMap " + index, priceItem, ex);
            }
        });
    }
};

window.onSeatMapUpdate = function () {
    if (!CurrencyManager.isEnabled()) return;
    CurrencyManager.updatePriceItemsSpecificSeatMap();
}

